/* eslint-disable */
import React from 'react'

export class CreateLinkIcon extends React.Component {
  render() {
    return (
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd"
              d="M8.56974 1.23201C10.2901 -0.431258 13.025 -0.407456 14.7162 1.28547C16.4071 2.978 16.4308 5.71441 14.7696 7.43609L14.7608 7.4451L12.5667 9.64143C11.6674 10.5419 10.4215 11.0072 9.15245 10.9162C7.88336 10.8253 6.71654 10.187 5.9547 9.16751C5.71427 8.84575 5.78019 8.39001 6.10194 8.14958C6.4237 7.90915 6.87944 7.97507 7.11987 8.29682C7.62915 8.97835 8.40884 9.40465 9.25646 9.46542C10.1041 9.52618 10.9364 9.21546 11.5374 8.61361L11.5375 8.61352L13.727 6.42182C14.8335 5.27048 14.8162 3.44364 13.6872 2.31347C12.5583 1.18346 10.734 1.16644 9.58434 2.27429L8.33026 3.52234C8.04555 3.80567 7.58507 3.80456 7.30174 3.51985C7.01841 3.23515 7.01952 2.77467 7.30422 2.49133L8.56223 1.23938L8.56974 1.23201Z"
              fill="#CCCCCC"/>
        <path fillRule="evenodd" clipRule="evenodd"
              d="M3.43353 6.35846C4.3328 5.45801 5.5786 4.99276 6.84766 5.08374C8.11675 5.17472 9.28357 5.81296 10.0454 6.83248C10.2858 7.15423 10.2199 7.60997 9.89816 7.8504C9.57641 8.09084 9.12067 8.02491 8.88024 7.70316C8.37096 7.02163 7.59127 6.59533 6.74365 6.53456C5.89604 6.4738 5.06369 6.78452 4.46266 7.38637L2.27307 9.57817C1.16662 10.7295 1.18388 12.5563 2.31291 13.6865C3.44155 14.8163 5.2653 14.8335 6.41505 13.7264L7.66104 12.4791C7.94491 12.195 8.40539 12.1948 8.68956 12.4786C8.97372 12.7625 8.97395 13.223 8.69007 13.5071L7.43938 14.7591L7.43037 14.768C5.70999 16.4312 2.97509 16.4074 1.28387 14.7145C-0.406963 13.022 -0.430705 10.2856 1.23047 8.5639L1.23932 8.55488L3.43353 6.35846C3.4335 6.35849 3.43356 6.35843 3.43353 6.35846Z"
              fill="#CCCCCC"/>
      </svg>

    );
  }
}

export const NoChartDataIcon = () => (
  <svg width="64" height="64" viewBox="0 0 64 64" fill="none">
    <path
      d="M49.3334 0H4C1.79087 0 0 1.79088 0 4.00002V36.0001C0 38.2093 1.79087 40.0002 4 40.0002H21.3334V37.3335H4C3.26362 37.3335 2.66662 36.7365 2.66662 36.0001V4.00002C2.66662 3.26364 3.26362 2.66664 4 2.66664H49.3334C50.0697 2.66664 50.6667 3.26364 50.6667 4.00002V28.0001H53.3334V4.00002C53.3334 1.79088 51.5425 0 49.3334 0Z"
      fill="#B0B2C0"
    />
    <path d="M18.6666 38.667H16V46.667H18.6666V38.667Z" fill="#B0B2C0" />
    <path
      d="M9.33423 32C8.59785 32 8.00085 31.403 8.00085 30.6666V28H5.33423V30.6666C5.33423 32.8758 7.1251 34.6667 9.33423 34.6667H12.0009V32H9.33423Z"
      fill="#B0B2C0"
    />
    <path d="M8.00085 22.667H5.33423V25.3336H8.00085V22.667Z" fill="#B0B2C0" />
    <path
      d="M48.7292 28.2421C46.0122 25.5246 42.3268 23.9979 38.484 23.998C30.4833 23.9984 23.9977 30.4846 23.9979 38.4854C23.9983 46.4861 30.4844 52.9718 38.4852 52.9715C42.3267 52.9714 46.0107 51.4455 48.7273 48.7294C54.3852 43.0725 54.386 33.9001 48.7292 28.2421ZM38.4772 50.3062C31.9492 50.3039 26.6589 45.0101 26.6612 38.4821C26.6634 31.9541 31.9572 26.6638 38.4852 26.6661C41.6228 26.6576 44.6332 27.9061 46.8438 30.1327C49.0585 32.35 50.3022 35.3561 50.3012 38.4901C50.2989 45.0181 45.0052 50.3084 38.4772 50.3062Z"
      fill="#B0B2C0"
    />
    <path
      d="M63.6099 57.9995L55.2405 49.6328C54.9905 49.3828 54.6514 49.2422 54.2979 49.2422C53.9442 49.2423 53.6052 49.3828 53.3552 49.6328L49.6352 53.3528C49.1147 53.8735 49.1147 54.7175 49.6352 55.2382L58.0046 63.6089C58.2546 63.859 58.5937 63.9995 58.9472 63.9995C59.3014 63.9984 59.6406 63.8564 59.8899 63.6049L63.6099 59.8849C64.1304 59.3641 64.1304 58.5201 63.6099 57.9995ZM58.9471 60.7809L52.4631 54.2955L54.2977 52.4608L60.7817 58.9462L58.9471 60.7809Z"
      fill="#B0B2C0"
    />
    <path
      d="M48.7291 46.84L46.8435 48.7256L51.4934 53.3755L53.379 51.4899L48.7291 46.84Z"
      fill="#B0B2C0"
    />
    <path
      d="M38.6667 29.333V31.9996C42.3469 32.004 45.329 34.9863 45.3334 38.6663H48C47.9942 33.5141 43.819 29.3389 38.6667 29.333Z"
      fill="#B0B2C0"
    />
    <path d="M24.0008 45.335H13.3342V48.0016H24.0008V45.335Z" fill="#B0B2C0" />
    <path
      d="M20 5.33301C17.7909 5.33301 16 7.12389 16 9.33302C16 11.5422 17.7909 13.333 20 13.333C22.2091 13.333 24 11.5422 24 9.33302C24 7.12389 22.2091 5.33301 20 5.33301ZM20 10.6663C19.2636 10.6663 18.6666 10.0693 18.6666 9.3329C18.6666 8.59652 19.2636 7.99952 20 7.99952C20.7364 7.99952 21.3334 8.59652 21.3334 9.3329C21.3334 10.0694 20.7364 10.6663 20 10.6663Z"
      fill="#B0B2C0"
    />
    <path
      d="M29.3341 14.667C27.125 14.667 25.3341 16.4579 25.3341 18.667C25.3341 20.8761 27.125 22.667 29.3341 22.667C31.5432 22.667 33.3341 20.8761 33.3341 18.667C33.3341 16.4579 31.5432 14.667 29.3341 14.667ZM29.3341 20.0004C28.5977 20.0004 28.0007 19.4034 28.0007 18.667C28.0007 17.9306 28.5977 17.3336 29.3341 17.3336C30.0705 17.3336 30.6675 17.9306 30.6675 18.667C30.6674 19.4034 30.0705 20.0004 29.3341 20.0004Z"
      fill="#B0B2C0"
    />
    <path
      d="M17.7232 9.72406L11.0566 16.3906L12.9422 18.2762L19.6087 11.6096L17.7232 9.72406Z"
      fill="#B0B2C0"
    />
    <path
      d="M22.2698 9.72477L20.3843 11.6104L27.0508 18.2769L28.9364 16.3913L22.2698 9.72477Z"
      fill="#B0B2C0"
    />
    <path
      d="M38.6667 5.33301C36.4576 5.33301 34.6667 7.12389 34.6667 9.33302C34.6667 11.5422 36.4576 13.333 38.6667 13.333C40.8759 13.333 42.6667 11.5422 42.6667 9.33302C42.6669 7.12389 40.876 5.33301 38.6667 5.33301ZM38.6667 10.6663C37.9304 10.6663 37.3334 10.0693 37.3334 9.3329C37.3334 8.59652 37.9304 7.99952 38.6667 7.99952C39.4031 7.99952 40.0001 8.59652 40.0001 9.3329C40.0001 10.0694 39.4031 10.6663 38.6667 10.6663Z"
      fill="#B0B2C0"
    />
    <path
      d="M36.3909 9.72992L29.7244 16.3965L31.6099 18.2821L38.2765 11.6155L36.3909 9.72992Z"
      fill="#B0B2C0"
    />
  </svg>
)

export class BroadcastIcon extends React.Component {
  render() {
    return (
      <svg
        width={this.props.width}
        height={this.props.height}
        viewBox="0 0 22 18"
        fill="none">
        <path
          d="M2 4C3.10457 4 4 3.10457 4 2C4 0.89543 3.10457 0 2 0C0.89543 0 0 0.89543 0 2C0 3.10457 0.89543 4 2 4Z"
          transform="translate(9 7)"
          stroke={this.props.color}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.2378 2.83C15.3645 3.95541 15.9975 5.48255 15.9975 7.075C15.9975 8.66746 15.3645 10.1946 14.2378 11.32V2.83ZM5.75777 11.31C4.6311 10.1846 3.99805 8.65745 3.99805 7.065C3.99805 5.47254 4.6311 3.94541 5.75777 2.82V11.31ZM17.0679 0C20.9717 3.905 20.9717 10.235 17.0679 14.14V0ZM2.92786 14.14C-0.975955 10.235 -0.975955 3.905 2.92786 0V14.14Z"
          transform="translate(1.0022 1.93)"
          stroke={this.props.color}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    )
  }
}

export class Chevron extends React.Component {
  render() {
    return (
      <svg
        width="11"
        height="7"
        viewBox="0 0 11 7"
        fill="none"
        className={this.props.classes}
        style={
          this.props.rotate
            ? {
              transform: 'rotate(180deg)',
            }
            : {}
        }>
        <path
          d="M1 1L5.5 6L10 1"
          stroke="#B0B2C0"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    )
  }
}

export class DashboardIcon extends React.Component {
  render() {
    return (
      <svg
        width={this.props.width}
        height={this.props.height}
        viewBox="0 0 22 22"
        fill="none">
        <path
          d="M10 0L0 5L10 10L20 5L10 0V0Z"
          transform="translate(1 1)"
          stroke={this.props.color}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M0 0L10 5L20 0"
          transform="translate(1 16)"
          stroke={this.props.color}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M0 0L10 5L20 0"
          transform="translate(1 11)"
          stroke={this.props.color}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    )
  }
}

export class FlowsIcon extends React.Component {
  render() {
    return (
      <svg
        width={this.props.width}
        height={this.props.height}
        viewBox="0 0 21 21"
        fill="none">
        <path
          d="M0 0H5V5"
          transform="translate(13.8691 1.95015) rotate(-0.831772)"
          stroke={this.props.color}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M0 17L17 0"
          transform="translate(1.87036 2.12434) rotate(-0.831772)"
          stroke={this.props.color}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5 0V5H0"
          transform="translate(14.0579 14.9488) rotate(-0.831772)"
          stroke={this.props.color}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M0 0L6 6"
          transform="translate(13.0435 13.9634) rotate(-0.831772)"
          stroke={this.props.color}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M0 0L5 5"
          transform="translate(1.88477 3.12424) rotate(-0.831772)"
          stroke={this.props.color}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    )
  }
}

export class NlpIcon extends React.Component {
  render() {
    return (
      <svg
        width={this.props.width}
        height={this.props.height}
        viewBox="0 0 22 22"
        fill="none">
        <path
          d="M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z"
          transform="translate(1 1)"
          stroke={this.props.color}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6 12C9.31371 12 12 9.31371 12 6C12 2.68629 9.31371 0 6 0C2.68629 0 0 2.68629 0 6C0 9.31371 2.68629 12 6 12Z"
          transform="translate(5 5)"
          stroke={this.props.color}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M2 4C3.10457 4 4 3.10457 4 2C4 0.89543 3.10457 0 2 0C0.89543 0 0 0.89543 0 2C0 3.10457 0.89543 4 2 4Z"
          transform="translate(9 9)"
          stroke={this.props.color}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    )
  }
}

export class SupportIcon extends React.Component {
  render() {
    return (
      <svg
        width={this.props.width}
        height={this.props.height}
        viewBox="0 0 20 20"
        fill="none">
        <path
          d="M0 15V9C7.40672e-08 4.02944 4.02944 0 9 0C13.9706 0 18 4.02944 18 9V15"
          transform="translate(1 1)"
          stroke={this.props.color}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M18 5C18 6.10457 17.1046 7 16 7H15C13.8954 7 13 6.10457 13 5V2C13 0.89543 13.8954 0 15 0H18V5ZM0 5C0 6.10457 0.89543 7 2 7H3C4.10457 7 5 6.10457 5 5V2C5 0.89543 4.10457 0 3 0H0V5Z"
          transform="translate(1 12)"
          stroke={this.props.color}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    )
  }
}

export class WidgetIcon extends React.Component {
  render() {
    return (
      <svg
        width={this.props.width}
        height={this.props.height}
        viewBox="0 0 20 20"
        fill="none">
        <path
          d="M18 12C18 13.1046 17.1046 14 16 14H4L0 18V2C0 0.89543 0.89543 0 2 0H16C17.1046 0 18 0.89543 18 2V12Z"
          transform="translate(1 1)"
          stroke={this.props.color}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    )
  }
}

export class SettingsIcon extends React.Component {
  render() {
    return (
      <svg
        width={this.props.width}
        height={this.props.height}
        viewBox="0 0 24 20"
        fill="none">
        <path
          d="M0 7V0"
          transform="translate(4 12)"
          stroke={this.props.color}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M0 7V0"
          transform="translate(4 1)"
          stroke={this.props.color}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M0 9V0"
          transform="translate(12 10)"
          stroke={this.props.color}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M0 5V0"
          transform="translate(12 1)"
          stroke={this.props.color}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M0 5V0"
          transform="translate(20 14)"
          stroke={this.props.color}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M0 9V0"
          transform="translate(20 1)"
          stroke={this.props.color}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M0 0H6"
          transform="translate(1 12)"
          stroke={this.props.color}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M0 0H6"
          transform="translate(9 6)"
          stroke={this.props.color}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M0 0H6"
          transform="translate(17 14)"
          stroke={this.props.color}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    )
  }
}

export const AnalyticsIcon = props => {
  return (
    <svg
      width={props.width}
      height={props.height}
      viewBox="0 0 24 24"
      fill="none">
      <path
        d="M23 6L13.5 15.5L8.5 10.5L1 18"
        stroke={props.color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17 6H23V12"
        stroke={props.color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export class PlusIcon extends React.Component {
  render() {
    return (
      <svg
        width={this.props.width}
        height={this.props.height}
        viewBox="0 0 13 13"
        fill="none">
        <path
          d="M0 0V11"
          transform="translate(6.5 1)"
          stroke={this.props.color}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M0 0H11"
          transform="translate(1 6.5)"
          stroke={this.props.color}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    )
  }
}

export class CloseIcon extends React.Component {
  render() {
    return (
      <svg
        width={this.props.width}
        height={this.props.height}
        viewBox="0 0 9 9"
        fill="none">
        <path
          d="M7 0L0 7"
          transform="translate(1 1)"
          stroke={this.props.color}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M0 0L7 7"
          transform="translate(1 1)"
          stroke={this.props.color}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    )
  }
}

export class SearchIcon extends React.Component {
  render() {
    return (
      <svg
        width={this.props.width}
        height={this.props.height}
        viewBox="0 0 20 20"
        fill="none">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.5 15C11.6421 15 15 11.6421 15 7.5C15 3.35786 11.6421 0 7.5 0C3.35786 0 0 3.35786 0 7.5C0 11.6421 3.35786 15 7.5 15Z"
          transform="translate(1 1)"
          stroke={this.props.color}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.2 5.2L0 0"
          transform="translate(13.8 13.8)"
          stroke={this.props.color}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    )
  }
}

export class TextIcon extends React.Component {
  render() {
    return (
      <svg
        width={this.props.width}
        height={this.props.height}
        viewBox="0 0 16 13"
        fill="none">
        <path
          d="M9.68406 0H0"
          transform="translate(2.9884 4.24988)"
          stroke={this.props.color}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13.9192 0H0"
          transform="translate(1 1.30762)"
          stroke={this.props.color}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13.9192 0H0"
          transform="translate(1 7.19226)"
          stroke={this.props.color}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.68406 0H0"
          transform="translate(2.9884 10.1345)"
          stroke={this.props.color}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    )
  }
}

export class ListIcon extends React.Component {
  render() {
    return (
      <svg
        width={this.props.width}
        height={this.props.height}
        viewBox="0 0 13 13"
        fill="none">
        <path
          d="M0 0H11"
          transform="translate(1 1.30762)"
          stroke={this.props.color}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M0 0H11"
          transform="translate(1 6.21143)"
          stroke={this.props.color}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M0 0H11"
          transform="translate(1 11.1154)"
          stroke={this.props.color}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    )
  }
}

export class GalleryIcon extends React.Component {
  render() {
    return (
      <svg
        width={this.props.width}
        height={this.props.height}
        viewBox="0 0 12 15"
        fill="none">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 2C0 0.89543 0.89543 0 2 0H7.94231C9.04688 0 9.94231 0.895431 9.94231 2V9.76923C9.94231 10.8738 9.04688 11.7692 7.94231 11.7692H2C0.895431 11.7692 0 10.8738 0 9.76923V2Z"
          transform="translate(10.9423 13.0769) rotate(180)"
          stroke={this.props.color}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    )
  }
}

export class AttachmentIcon extends React.Component {
  render() {
    return (
      <svg
        width={this.props.width}
        height={this.props.height}
        viewBox="0 0 19 11"
        fill="none">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.7558 0H13.0606C14.0794 0 15.0565 0.413323 15.7768 1.14904C16.4972 1.88476 16.902 2.88261 16.902 3.92308C16.902 6.08973 15.1821 7.84615 13.0606 7.84615H10.7558V0ZM6.14615 7.84615H3.84135C2.82256 7.84615 1.8455 7.43283 1.1251 6.69711C0.404712 5.96139 0 4.96354 0 3.92308C0 1.75642 1.71983 0 3.84135 0H6.14615V7.84615Z"
          transform="translate(1 1.30762)"
          stroke={this.props.color}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M0 0H5.96538"
          transform="translate(5.97113 5.23071)"
          stroke={this.props.color}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    )
  }
}

export class ReplyIcon extends React.Component {
  render() {
    return (
      <svg
        width={this.props.width}
        height={this.props.height}
        viewBox="0 0 19 14"
        fill="none">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 5.39423C0 2.41508 2.41508 0 5.39423 0H11.5077C14.4868 0 16.9019 2.41508 16.9019 5.39423V5.39423C16.9019 8.37338 14.4868 10.7885 11.5077 10.7885H5.39423C2.41508 10.7885 0 8.37338 0 5.39423V5.39423Z"
          transform="translate(1 1.30762)"
          stroke={this.props.color}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    )
  }
}

export class OtherIcon extends React.Component {
  render() {
    return (
      <svg
        width={this.props.width}
        height={this.props.height}
        viewBox="0 0 19 6"
        fill="none">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1.49135 2.94231C2.31499 2.94231 2.98269 2.28365 2.98269 1.47115C2.98269 0.658658 2.31499 0 1.49135 0C0.667698 0 0 0.658658 0 1.47115C0 2.28365 0.667698 2.94231 1.49135 2.94231Z"
          transform="translate(7.95959 1.30762)"
          stroke={this.props.color}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1.49135 2.94231C2.31499 2.94231 2.98269 2.28365 2.98269 1.47115C2.98269 0.658658 2.31499 0 1.49135 0C0.667698 0 0 0.658658 0 1.47115C0 2.28365 0.667698 2.94231 1.49135 2.94231Z"
          transform="translate(14.9193 1.30762)"
          stroke={this.props.color}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1.49135 2.94231C2.31499 2.94231 2.98269 2.28365 2.98269 1.47115C2.98269 0.658658 2.31499 0 1.49135 0C0.667698 0 0 0.658658 0 1.47115C0 2.28365 0.667698 2.94231 1.49135 2.94231Z"
          transform="translate(1 1.30762)"
          stroke={this.props.color}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    )
  }
}

export class DoneIcon extends React.Component {
  render() {
    return (
      <svg width="18" height="13" viewBox="0 0 18 13" fill="none">
        <path
          d="M16 0L5 11L0 6"
          transform="translate(1 1)"
          stroke={this.props.color ? this.props.color : '#11C314'}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    )
  }
}

export class LeftArrowIcon extends React.Component {
  render() {
    return (
      <svg width="7" height="11" viewBox="0 0 7 11" fill="none">
        <path
          d="M0 0L4.5 5L9 0"
          transform="translate(6 10) scale(-1 1) rotate(-90)"
          stroke="#B0B2C0"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    )
  }
}

export class RightArrowIcon extends React.Component {
  render() {
    return (
      <svg width="7" height="11" viewBox="0 0 7 11" fill="none">
        <path
          d="M0 0L4.5 5L9 0"
          transform="translate(1 10) rotate(-90)"
          stroke={this.props.color ? this.props.color : '#B0B2C0'}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    )
  }
}

export class DownArrowIcon extends React.Component {
  render() {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="10"
        height="6"
        viewBox="0 0 10 6"
        fill="none">
        <path
          d="M1 1L5 5L9 1"
          stroke="#B0B2C0"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    )
  }
}

export class EditIcon extends React.Component {
  render() {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none">
        <path
          d="M17 3C17.2626 2.73735 17.5744 2.52901 17.9176 2.38687C18.2608 2.24473 18.6286 2.17157 19 2.17157C19.3714 2.17157 19.7392 2.24473 20.0824 2.38687C20.4256 2.52901 20.7374 2.73735 21 3C21.2626 3.26264 21.471 3.57444 21.6131 3.9176C21.7553 4.26077 21.8284 4.62856 21.8284 5C21.8284 5.37143 21.7553 5.73923 21.6131 6.08239C21.471 6.42555 21.2626 6.73735 21 7L7.5 20.5L2 22L3.5 16.5L17 3Z"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    )
  }
}

export class OvalIcon extends React.Component {
  render() {
    return (
      <svg width="5" height="5" viewBox="0 0 5 5" fill="none">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1.5 3C2.32843 3 3 2.32843 3 1.5C3 0.671573 2.32843 0 1.5 0C0.671573 0 0 0.671573 0 1.5C0 2.32843 0.671573 3 1.5 3Z"
          transform="translate(1 1)"
          stroke="#1658F3"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    )
  }
}

export class CalendarIcon extends React.Component {
  render() {
    const { width, height } = this.props
    return (
      <svg
        width={width || '20'}
        height={height || '22'}
        viewBox="0 0 20 22"
        fill="none">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 2C0 0.89543 0.895431 0 2 0H16C17.1046 0 18 0.895431 18 2V16C18 17.1046 17.1046 18 16 18H2C0.89543 18 0 17.1046 0 16V2Z"
          transform="translate(1 3)"
          stroke="#B0B2C0"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M0 0V4"
          transform="translate(14 1)"
          stroke="#B0B2C0"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M0 0V4"
          transform="translate(6 1)"
          stroke="#B0B2C0"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M0 0H18"
          transform="translate(1 9)"
          stroke="#B0B2C0"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    )
  }
}

export class PenIcon extends React.Component {
  render() {
    return (
      <svg width="12" height="12" viewBox="0 0 14 14" fill="none">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.66667 0L12 3.33333L3.33333 12H0V8.66667L8.66667 0Z"
          transform="translate(1 1)"
          stroke="#B0B2C0"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    )
  }
}

export class PhotoIcon extends React.Component {
  render() {
    return (
      <svg
        width={this.props.width}
        height={this.props.height}
        viewBox="0 0 21 17"
        fill="none">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M19 13.3333C19 14.2538 18.2267 15 17.2727 15H1.72727C0.773326 15 0 14.2538 0 13.3333V4.16667C0 3.24619 0.773326 2.5 1.72727 2.5H5.18182L6.90909 0H12.0909L13.8182 2.5H17.2727C18.2267 2.5 19 3.24619 19 4.16667V13.3333Z"
          transform="translate(1 1)"
          stroke="#B0B2C0"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2.5 5C3.88071 5 5 3.88071 5 2.5C5 1.11929 3.88071 0 2.5 0C1.11929 0 0 1.11929 0 2.5C0 3.88071 1.11929 5 2.5 5Z"
          transform="translate(8 7)"
          stroke="#B0B2C0"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    )
  }
}

export class EnterIcon extends React.Component {
  render() {
    return (
      <svg
        width={this.props.width}
        height={this.props.height}
        viewBox="0 0 16 16"
        fill="none">
        <rect
          width="14"
          height="14"
          fill="black"
          fillOpacity="0"
          transform="translate(1 1)"
        />
        <rect
          width="14"
          height="14"
          fill="black"
          fillOpacity="0"
          transform="translate(1 1)"
        />
        <path
          d="M5.375 6.25L1 10.625L5.375 15"
          stroke={this.props.color}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15 1V7.125C15 9.058 13.433 10.625 11.5 10.625H1"
          stroke={this.props.color}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    )
  }
}

export class UpIcon extends React.Component {
  render() {
    return (
      <svg width="12" height="16" viewBox="0 0 28 36" fill="none">
        <rect
          width="12"
          height="16"
          fill="black"
          fillOpacity="0"
          transform="translate(2 2) scale(2)"
        />
        <path
          d="M14 34V2"
          stroke="#B0B2C0"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M2 14L14 2L26 14"
          stroke="#B0B2C0"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    )
  }
}

export class DownIcon extends React.Component {
  render() {
    return (
      <svg width="12" height="16" viewBox="0 0 28 36" fill="none">
        <rect
          width="12"
          height="16"
          fill="black"
          fillOpacity="0"
          transform="translate(2 2) scale(2)"
        />
        <path
          d="M14 2V34"
          stroke="#B0B2C0"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M26 22L14 34L2 22"
          stroke="#B0B2C0"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    )
  }
}

export class Icon404 extends React.Component {
  render() {
    return (
      <svg width="354" height="153" viewBox="0 0 354 153" fill="none">
        <path
          d="M58.3865 117.374H9.04498C3.90575 117.374 0 113.885 0 107.934C0 106.293 27.1349 6.97684 27.1349 6.97684C29.6019 1.84669 34.125 0 38.4422 0C43.1707 0 55.029 3.18409 55.029 9.3411C55.029 10.3673 55.0795 12.5176 54.4621 13.748L34.3318 92.5442H58.3865V70.9988C58.3865 65.0489 65.1706 62.5859 71.7493 62.5859C78.5348 62.5859 85.1128 65.0482 85.1128 70.9988V92.5442H94.7752C100.327 92.5442 103.205 98.7006 103.205 105.061C103.205 111.217 99.0917 117.374 94.7752 117.374H85.1128V141.587C85.1128 147.128 78.5341 150 71.7493 150C65.1706 150 58.3865 147.127 58.3865 141.587V117.374Z"
          fill="#5A98F7"
          fillOpacity="0.5"
        />
        <path
          d="M270.004 36.0587C274.461 19.6718 277.929 6.97684 277.929 6.97684C280.396 1.84669 284.919 0 289.237 0C293.965 0 305.823 3.18409 305.823 9.3411C305.823 10.3673 305.874 12.5176 305.257 13.748L285.127 92.5442H309.182V70.9988C309.182 65.0489 315.966 62.5859 322.544 62.5859C329.33 62.5859 335.908 65.0482 335.908 70.9988V92.5442H345.57C351.122 92.5442 354 98.7006 354 105.061C354 111.217 349.887 117.374 345.57 117.374H335.908V141.587C335.908 147.128 329.329 150 322.544 150C315.966 150 309.182 147.127 309.182 141.587V117.374H259.839C254.7 117.374 250.794 113.885 250.794 107.934C250.794 107.112 257.598 81.8009 264.392 56.7312L270.004 36.0587Z"
          fill="#5A98F7"
          fillOpacity="0.5"
        />
        <g filter="url(#filter0_d)">
          <path
            d="M177.006 140.941C210.793 140.941 238.182 113.603 238.182 79.8809C238.182 46.1583 210.793 18.8208 177.006 18.8208C143.219 18.8208 115.83 46.1583 115.83 79.8809C115.83 113.603 143.219 140.941 177.006 140.941Z"
            fill="url(#paint0_linear)"
          />
        </g>
        <path
          d="M184.667 79.8832L205.946 58.6442C208.062 56.5325 208.062 53.1076 205.946 50.9966C203.829 48.8849 200.399 48.8849 198.283 50.9966L177.004 72.2356L155.724 50.9966C153.607 48.8849 150.177 48.8849 148.061 50.9966C145.946 53.1083 145.946 56.5332 148.061 58.6442L169.341 79.8832L148.061 101.122C145.946 103.234 145.946 106.659 148.061 108.77C149.12 109.826 150.507 110.354 151.893 110.354C153.279 110.354 154.666 109.826 155.725 108.77L177.004 87.5308L198.284 108.77C199.342 109.826 200.729 110.354 202.116 110.354C203.502 110.354 204.889 109.826 205.947 108.77C208.063 106.658 208.063 103.233 205.947 101.122L184.667 79.8832Z"
          fill="white"
        />
        <defs>
          <filter
            id="filter0_d"
            x="106.83"
            y="12.8208"
            width="140.353"
            height="140.12"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB">
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            />
            <feOffset dy="3" />
            <feGaussianBlur stdDeviation="4.5" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0.0742893 0 0 0 0 0.269578 0 0 0 0 0.72821 0 0 0 0.206267 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow"
              result="shape"
            />
          </filter>
          <linearGradient
            id="paint0_linear"
            x1="291.149"
            y1="74.0012"
            x2="171.744"
            y2="-34.3433"
            gradientUnits="userSpaceOnUse">
            <stop stopColor="#5A98F7" />
            <stop offset="1" stopColor="#1658F3" />
          </linearGradient>
        </defs>
      </svg>
    )
  }
}

export class ThreeIcon extends React.Component {
  render() {
    return (
      <svg width="22" height="6" viewBox="0 0 22 6" fill="none">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11 5C12.1046 5 13 4.10457 13 3C13 1.89543 12.1046 1 11 1C9.89543 1 9 1.89543 9 3C9 4.10457 9.89543 5 11 5Z"
          stroke="#B0B2C0"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M19 5C20.1046 5 21 4.10457 21 3C21 1.89543 20.1046 1 19 1C17.8954 1 17 1.89543 17 3C17 4.10457 17.8954 5 19 5Z"
          stroke="#B0B2C0"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3 5C4.10457 5 5 4.10457 5 3C5 1.89543 4.10457 1 3 1C1.89543 1 1 1.89543 1 3C1 4.10457 1.89543 5 3 5Z"
          stroke="#B0B2C0"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    )
  }
}

export class BackIcon extends React.Component {
  render() {
    return (
      <svg width="8" height="14" viewBox="0 0 8 14" fill="none">
        <path
          d="M7 13L1 7L7 1"
          stroke="#3A3F62"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    )
  }
}

export class EditMenuIcon extends React.Component {
  render() {
    return (
      <svg width="6" height="9" viewBox="0 0 6 9" fill="none">
        <path
          d="M1 8L5 4.5L1 1"
          stroke="#1658F3"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    )
  }
}

export class LinkIcon extends React.Component {
  render() {
    return (
      <svg width="22" height="22" viewBox="0 0 22 22" fill="none">
        <path
          d="M8.98865 12.0067C9.86254 13.1762 11.2008 13.908 12.656 14.0123C14.1112 14.1167 15.54 13.5832 16.5714 12.5503L19.5885 9.53023C21.4941 7.55522 21.4668 4.41583 19.5272 2.47426C17.5876 0.532693 14.4514 0.505413 12.4783 2.41295L10.7486 4.13438"
          stroke="#8EB0F8"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13.0114 9.99331C12.1375 8.82385 10.7992 8.09198 9.344 7.98765C7.88877 7.88333 6.46001 8.41683 5.42856 9.4497L2.41153 12.4698C0.50591 14.4448 0.533163 17.5842 2.47278 19.5257C4.4124 21.4673 7.54863 21.4946 9.52166 19.5871L11.2414 17.8656"
          stroke="#8EB0F8"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    )
  }
}

export class WelcomeIcon extends React.Component {
  render() {
    return (
      <svg width="20" height="14" viewBox="0 0 20 14" fill="none">
        <path
          d="M15 5H1"
          stroke="#8EB0F8"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M19 1H1"
          stroke="#8EB0F8"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M19 9H1"
          stroke="#8EB0F8"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15 13H1"
          stroke="#8EB0F8"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    )
  }
}

export class DelayIcon extends React.Component {
  render() {
    return (
      <svg width="22" height="22" viewBox="0 0 22 22" fill="none">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11 21C16.5228 21 21 16.5228 21 11C21 5.47715 16.5228 1 11 1C5.47715 1 1 5.47715 1 11C1 16.5228 5.47715 21 11 21Z"
          stroke="#8EB0F8"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11 7V11"
          stroke="#8EB0F8"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    )
  }
}

export class CustomizationIcon extends React.Component {
  render() {
    return (
      <svg width="20" height="22" viewBox="0 0 20 22" fill="none">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12 1L16 5L5 16H1V12L12 1V1Z"
          stroke="#8EB0F8"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M1 21H19"
          stroke="#8EB0F8"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    )
  }
}

export class HelloIcon extends React.Component {
  render() {
    return (
      <svg width="14" height="15" viewBox="0 0 14 15" fill="none">
        <path
          opacity="0.5"
          d="M0 14.63H14V0.63H0V14.63Z"
          fill="url(#pattern0)"
        />
        <defs>
          <pattern
            id="pattern0"
            patternContentUnits="objectBoundingBox"
            width="1"
            height="1">
            <use href="#image0" transform="scale(0.015625)" />
          </pattern>
          <image
            id="image0"
            width="64"
            height="64"
            href="data:image/png;base64,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"
          />
        </defs>
      </svg>
    )
  }
}

export const CopyIcon = props => {
  const { width, height, color } = props
  return (
    <svg
      width={width || 20}
      height={height || 20}
      viewBox="0 0 20 20"
      fill="none">
      <path
        d="M17.1998 7.30002H9.0998C8.10569 7.30002 7.2998 8.10591 7.2998 9.10002V17.2C7.2998 18.1941 8.10569 19 9.0998 19H17.1998C18.1939 19 18.9998 18.1941 18.9998 17.2V9.10002C18.9998 8.10591 18.1939 7.30002 17.1998 7.30002Z"
        stroke={color || '#354052}'}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.7 12.7H2.8C2.32261 12.7 1.86477 12.5104 1.52721 12.1728C1.18964 11.8352 1 11.3774 1 10.9V2.8C1 2.32261 1.18964 1.86477 1.52721 1.52721C1.86477 1.18964 2.32261 1 2.8 1H10.9C11.3774 1 11.8352 1.18964 12.1728 1.52721C12.5104 1.86477 12.7 2.32261 12.7 2.8V3.7"
        stroke={color || '#354052}'}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export const TrashDarkIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path
      d="M3 6H5H21"
      stroke="#354052"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8 6V4C8 3.46957 8.21071 2.96086 8.58579 2.58579C8.96086 2.21071 9.46957 2 10 2H14C14.5304 2 15.0391 2.21071 15.4142 2.58579C15.7893 2.96086 16 3.46957 16 4V6M19 6V20C19 20.5304 18.7893 21.0391 18.4142 21.4142C18.0391 21.7893 17.5304 22 17 22H7C6.46957 22 5.96086 21.7893 5.58579 21.4142C5.21071 21.0391 5 20.5304 5 20V6H19Z"
      stroke="#354052"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10 11V17"
      stroke="#354052"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14 11V17"
      stroke="#354052"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const ChevronLeftIcon = () => (
  <svg width="7" height="11" viewBox="0 0 7 11" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M6 10L1 5.5L6 1" stroke="#B0B2C0" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
  </svg>
)

export const ChevronRightIcon = () => (
  <svg width="7" height="11" viewBox="0 0 7 11" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M1 10L6 5.5L1 1" stroke="#B0B2C0" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
  </svg>
)

export const LongArrowLeftIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M3.33337 9.99996C3.33337 9.53972 3.70647 9.16663 4.16671 9.16663H15.8334C16.2936 9.16663 16.6667 9.53972 16.6667 9.99996C16.6667 10.4602 16.2936 10.8333 15.8334 10.8333H4.16671C3.70647 10.8333 3.33337 10.4602 3.33337 9.99996Z"
      fill="#1658F3"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M10.5893 3.57745C10.9147 3.90289 10.9147 4.43053 10.5893 4.75596L5.34522 10L10.5893 15.2441C10.9147 15.5696 10.9147 16.0972 10.5893 16.4226C10.2639 16.7481 9.73622 16.7481 9.41078 16.4226L3.57745 10.5893C3.25201 10.2639 3.25201 9.73622 3.57745 9.41078L9.41078 3.57745C9.73622 3.25201 10.2639 3.25201 10.5893 3.57745Z"
      fill="#1658F3"
    />
  </svg>
)

export const LongArrowRightIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M16.6666 10C16.6666 10.4603 16.2935 10.8334 15.8333 10.8334L4.16663 10.8334C3.70639 10.8334 3.33329 10.4603 3.33329 10C3.33329 9.5398 3.70639 9.16671 4.16663 9.16671L15.8333 9.16671C16.2935 9.16671 16.6666 9.5398 16.6666 10Z"
      fill="white"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M9.41071 16.4225C9.08527 16.0971 9.08527 15.5695 9.41071 15.244L14.6548 9.99996L9.41071 4.75588C9.08527 4.43045 9.08527 3.90281 9.41071 3.57737C9.73614 3.25194 10.2638 3.25194 10.5892 3.57737L16.4225 9.41071C16.748 9.73614 16.748 10.2638 16.4225 10.5892L10.5892 16.4225C10.2638 16.748 9.73614 16.748 9.41071 16.4225Z"
      fill="white"
    />
  </svg>
)

export const MoreHorizontalIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13Z"
      stroke="#354052"
      stroke-opacity="0.7"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M19 13C19.5523 13 20 12.5523 20 12C20 11.4477 19.5523 11 19 11C18.4477 11 18 11.4477 18 12C18 12.5523 18.4477 13 19 13Z"
      stroke="#354052"
      stroke-opacity="0.7"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M5 13C5.55228 13 6 12.5523 6 12C6 11.4477 5.55228 11 5 11C4.44772 11 4 11.4477 4 12C4 12.5523 4.44772 13 5 13Z"
      stroke="#354052"
      stroke-opacity="0.7"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
)

export const DeleteIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M8.33335 8.33337C8.79359 8.33337 9.16669 8.70647 9.16669 9.16671V14.1667C9.16669 14.6269 8.79359 15 8.33335 15C7.87312 15 7.50002 14.6269 7.50002 14.1667V9.16671C7.50002 8.70647 7.87312 8.33337 8.33335 8.33337Z"
      fill="#FF6666"
    />
    <path
      d="M12.5 14.1667V9.16671C12.5 8.70647 12.1269 8.33337 11.6667 8.33337C11.2064 8.33337 10.8334 8.70647 10.8334 9.16671V14.1667C10.8334 14.6269 11.2064 15 11.6667 15C12.1269 15 12.5 14.6269 12.5 14.1667Z"
      fill="#FF6666"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M5.83335 4.16671V3.33337C5.83335 2.67033 6.09675 2.03445 6.56559 1.56561C7.03443 1.09677 7.67031 0.833374 8.33335 0.833374H11.6667C12.3297 0.833374 12.9656 1.09677 13.4345 1.56561C13.9033 2.03445 14.1667 2.67033 14.1667 3.33337V4.16671H17.5C17.9603 4.16671 18.3334 4.5398 18.3334 5.00004C18.3334 5.46028 17.9603 5.83337 17.5 5.83337H16.6667V16.6667C16.6667 17.3297 16.4033 17.9656 15.9345 18.4345C15.4656 18.9033 14.8297 19.1667 14.1667 19.1667H5.83335C5.17031 19.1667 4.53443 18.9033 4.06559 18.4345C3.59675 17.9656 3.33335 17.3297 3.33335 16.6667V5.83337H2.50002C2.03978 5.83337 1.66669 5.46028 1.66669 5.00004C1.66669 4.5398 2.03978 4.16671 2.50002 4.16671H5.83335ZM7.7441 2.74412C7.90038 2.58784 8.11234 2.50004 8.33335 2.50004H11.6667C11.8877 2.50004 12.0997 2.58784 12.2559 2.74412C12.4122 2.9004 12.5 3.11236 12.5 3.33337V4.16671H7.50002V3.33337C7.50002 3.11236 7.58782 2.9004 7.7441 2.74412ZM5.00002 5.83337V16.6667C5.00002 16.8877 5.08782 17.0997 5.2441 17.256C5.40038 17.4122 5.61234 17.5 5.83335 17.5H14.1667C14.3877 17.5 14.5997 17.4122 14.7559 17.256C14.9122 17.0997 15 16.8877 15 16.6667V5.83337H5.00002Z"
      fill="#FF6666"
    />
  </svg>
)

export const TrashIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M2 4H3.33333H14" stroke="#6D7686" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path
      d="M12.6667 4.00016V13.3335C12.6667 13.6871 12.5262 14.0263 12.2762 14.2763C12.0261 14.5264 11.687 14.6668 11.3334 14.6668H4.66671C4.31309 14.6668 3.97395 14.5264 3.7239 14.2763C3.47385 14.0263 3.33337 13.6871 3.33337 13.3335V4.00016M5.33337 4.00016V2.66683C5.33337 2.31321 5.47385 1.97407 5.7239 1.72402C5.97395 1.47397 6.31309 1.3335 6.66671 1.3335H9.33337C9.687 1.3335 10.0261 1.47397 10.2762 1.72402C10.5262 1.97407 10.6667 2.31321 10.6667 2.66683V4.00016"
      stroke="#6D7686"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const ReactionIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M5.77782 6.51868H5.78523M10.2223 6.51868H10.2297M6.14819 10.2224C6.38958 10.4688 6.67771 10.6645 6.99569 10.7981C7.31367 10.9317 7.65512 11.0005 8.00004 11.0005C8.34496 11.0005 8.68641 10.9317 9.00439 10.7981C9.32238 10.6645 9.6105 10.4688 9.85189 10.2224M1.33337 8.00016C1.33337 8.87564 1.50581 9.74255 1.84084 10.5514C2.17588 11.3602 2.66694 12.0952 3.286 12.7142C3.90505 13.3333 4.63998 13.8243 5.44882 14.1594C6.25766 14.4944 7.12456 14.6668 8.00004 14.6668C8.87552 14.6668 9.74243 14.4944 10.5513 14.1594C11.3601 13.8243 12.095 13.3333 12.7141 12.7142C13.3331 12.0952 13.8242 11.3602 14.1592 10.5514C14.4943 9.74255 14.6667 8.87564 14.6667 8.00016C14.6667 7.12468 14.4943 6.25778 14.1592 5.44894C13.8242 4.6401 13.3331 3.90517 12.7141 3.28612C12.095 2.66706 11.3601 2.176 10.5513 1.84097C9.74243 1.50593 8.87552 1.3335 8.00004 1.3335C7.12456 1.3335 6.25766 1.50593 5.44882 1.84097C4.63998 2.176 3.90505 2.66706 3.286 3.28612C2.66694 3.90517 2.17588 4.6401 1.84084 5.44894C1.50581 6.25778 1.33337 7.12468 1.33337 8.00016Z"
      stroke="#6D7686"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const CheckIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M13.3333 4L5.99996 11.3333L2.66663 8" stroke="#11C314" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
)
